import { Role } from 'constants/roles';

import { useMemo } from 'react';

import { usePermissions } from './usePermissions';

export const useCheckPaymentAccess = () => {
  const { roles } = usePermissions();

  return {
    isHavePaymentAccess: useMemo(() => {
      return (
        roles.includes(Role.Admin) || roles.includes(Role.Tech) || roles.includes(Role.Payment)
      );
    }, [roles]),
  };
};
